<template>
  <div class="header-container">
    <van-image @click="$router.push('/home')" class="logo-container" :src="require('@/assets/images/logo.png')" />

    <div class="search-and-change-container">
      <div class="search-container" @click="jump">
        <div class="search-icon"></div>
        <span>检索</span>
      </div>
      <div class="change-text-container" @click="onJump">电脑版</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderCom",
  methods: {
    jump() {
      this.$router.push("/search");
    },
    onJump() {
      window.open("https://www.cs.com.cn/?f=csmobile");
      // window.location.href = "https://www.cs.com.cn/?f=csmobile";
      // window.location.href = "https://www.cs.com.cn/test09/test_mq/01/index.html?f=csmobile";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
